"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REFRESH_APPLICATION_STATE = void 0;
exports.REFRESH_APPLICATION_STATE = '@user/REFRESH_APPLICATION_STATE';